import { ref, onMounted, onUnmounted, nextTick } from 'vue'

/**
 * 根据容器高度自动控制展开/收起
 * @param {Ref<HTMLElement|null>} containerRef - 容器 ref
 */
export function useCollapseByHeight(containerRef) {
  const isExpand = ref(false) // 是否展开
  const showToggle = ref(false) // 是否显示按钮
  const rowHeight = ref(0) // 一行高度
  const fullHeight = ref(0) // 容器全部高度
  let resizeObserver = null
  const toggleExpand = () => {
    isExpand.value = !isExpand.value
  }

  const calcHeights = () => {
    if (!containerRef.value) return
    const el = containerRef.value
    const firstItem = el.querySelector('.condition-item')
    if (firstItem) {
      const style = getComputedStyle(firstItem)
      rowHeight.value = firstItem.offsetHeight + parseInt(style.marginBottom) + 12
    }
    // 容器实际内容高度
    fullHeight.value = el.scrollHeight
    // 实际行数
    const rows = Math.round(fullHeight.value / rowHeight.value)
    // 只有超过一行才显示展开/收起按钮
    showToggle.value = rows > 1
  }

  onMounted(async () => {
    await nextTick()
    calcHeights()
    if (containerRef.value) {
      resizeObserver = new ResizeObserver(() => {
        calcHeights()
      })
      resizeObserver.observe(containerRef.value)
    }
  })

  onUnmounted(() => {
    if (resizeObserver && containerRef.value) {
      resizeObserver.unobserve(containerRef.value)
    }
  })

  return {
    isExpand,
    showToggle,
    rowHeight,
    fullHeight,
    toggleExpand,
    calcHeights
  }
}
